export interface GroupTypeData {
  name: string;
}

export interface SiteGroupData {
  name: string;
  siteIds: string[];
}

export interface SiteAddressData {
  city?: string;
  country?: string;
  postalCode?: string;
  state?: string;
  street?: string;
}

export interface ContactInformation {
  contactPerson?: string;
  phoneNumber?: string;
  phoneNumberCountryCode?: string;
  email?: string;
}

export interface GeolocationCoordinates {
  latitude: number;
  longitude: number;
}

export interface KeyValueData {
  key: string;
  value?: string;
}

export interface CustomAttributesData {
  attributes: KeyValueData[];
  typeName: string;
}

export type TDay = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';

export type TDayPartDay = TDay | 'DAILY';

export interface DayPart {
  day: TDayPartDay;
  description: string;
  endTime: string;
  name: string;
  startTime: string;
}

export interface TimePeriod {
  day: TDayPartDay;
  time?: string;
}

export interface SiteHours {
  open?: TimePeriod;
  close?: TimePeriod;
}

export type TStatus = 'ACTIVE' | 'INACTIVE';

export interface SiteData {
  address?: SiteAddressData;
  contact?: ContactInformation;
  coordinates?: GeolocationCoordinates;
  currency?: string;
  customAttributeSets?: CustomAttributesData[];
  description?: string;
  enterpriseUnitName?: string;
  locked?: boolean;
  parentEnterpriseUnitId?: string;
  siteName?: string;
  status?: TStatus;
  timeZone?: string;
}

export interface UpdateSiteData extends SiteData {
  hours?: SiteHours[];
  dayparts?: DayPart[];
  referenceId?: string;
}

export interface FindSitesCriteria extends SiteData {
  group?: string;
  isGrouped?: boolean;
}

export enum SiteFields {
  ADDRESS = 'address',
  CONTACT = 'contact',
  COORDINATES = 'coordinates',
  CURRENCY = 'currency',
  DAY_PARTS = 'dayparts',
  DESCRIPTION = 'description',
  GROUPS = 'groups',
  HOURS = 'hours',
  LOCKED = 'locked',
  PARENT_ENTERPRISE_UNIT_ID = 'parentEnterpriseUnitId',
  REFERENCE_ID = 'referenceId',
  STATUS = 'status',
  TIME_ZONE = 'timeZone',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortColumn {
  CITY = 'city',
  POSTAL_CODE = 'postalCode',
  SITE_NAME = 'siteName',
  STATE = 'state',
  STREET = 'street',
}

export interface SiteCriteriaSort {
  column: SortColumn;
  direction: SortDirection;
}

export interface FindSitesByCriteria {
  criteria: FindSitesCriteria;
  customAttributes: string[];
  fields: SiteFields[];
  sort: SiteCriteriaSort[];
}

export interface CreateSiteRequest extends UpdateSiteData {
  enterpriseUnitName: string;
  siteName: string;
  status: TStatus;
}

export interface CreateSiteTagRequest {
  name: string;
  icon: string;
}

export interface EnterpriseUnitIdData {
  enterpriseUnitId: string;
}

export interface AddEnterpriseUnitsRequest {
  enterpriseUnits: EnterpriseUnitIdData[];
}

export interface AssignSitesRequest {
  enterpriseGroupNames: string[];
  enterpriseUnitIds: string[];
}

export interface EnterpriseGroupWithUnitsMapping {
  enterpriseGroupName: string;
  enterpriseUnitIds: string[];
}

export class RemoveSitesRequest {
  removeSitesFromTagMapping: EnterpriseGroupWithUnitsMapping[];
}

export interface EnterpriseUnitGroupIdData {
  groupName: string;
}

export interface EnterpriseUnitGroupBasicData {
  category?: string;
  description?: string;
  displayName?: string;
}

export interface CreateEnterpriseUnitGroupRequest extends EnterpriseUnitGroupBasicData {
  groupId: EnterpriseUnitGroupIdData;
}
